export const BASE = process.env.NODE_ENV === "development" ? "http://localhost:3001" : "https://wood-it.ll-01.thedock.space";
